import { all, call, delay, put, takeLatest } from "redux-saga/effects";
import queryString from "query-string";

import { getErrorMessage } from "../../../../utils/sagasErrorHandler";
import { editConfigRequest, getConfigRequest, getHttpResponseRequest, getTracksRequest } from "../../api";
import { TRACKER_GENERAL_FILTER } from "../../../Tracker/constants";
import { QUICK_START_DATA } from "../../constants";
import { checkStatusScrapeTaskRequest, createQuickStartRequest } from "../../steps/One/services/api";
import { sharedHistory } from "../../../../routes/sharedHistory";

import { requestConfigData, setConfigData, setHttpResponse, setIsLoading, setScrapeTask } from "./actions";

function* handleCheckTraceResponse(id) {
    try{
        return yield call(checkStatusScrapeTaskRequest, id);
    }catch (error){
        return false;
    }
}

export function* handleCheckTrackIds(trackIds) {
    const data = yield all(
        trackIds.map((id) => handleCheckTraceResponse(id))
    );

    const notFinished = data.reduce(
        (acc, { id, is_finished }) => {
            if(!is_finished){
                acc.push(id);
            }

            return acc;
        },
        []
    );

    if(notFinished.length){
        yield delay(3000);

        yield handleCheckTrackIds(notFinished);
    }
}

function* handleRequestInitialScrapeTask({ payload }) {
    try {
        yield put(setIsLoading(true));
        const { initial_track_id, track_id, branch_codes, receiver_code, storage_type_code, template_code } = payload;

        const params = {
            sandbox_mode: true,
            trim_javascript: true,
            use_absolute_path: true,
            storage_type_code
        };

        const configParams = {
            sandbox_mode: true,
            branch_codes,
            receiver_code,
            storage_type_code
        };

        let initIds;
        if(Array.isArray(initial_track_id)) {
            initIds = initial_track_id;
        }else{
            initIds = [ initial_track_id ];
        }

        const responce = yield all(
            initIds.map(id => call(getHttpResponseRequest, { ...params, id, initial_track_id: track_id }))
        );
        yield put(setHttpResponse(responce));

        const { configs } = yield call(getConfigRequest, configParams);
        const config = configs[0];
        yield put(setConfigData(config));

        if(track_id) {
            const { scrape_tasks } = yield getTracksRequest({ ...TRACKER_GENERAL_FILTER, track_id });
            const track = scrape_tasks[0];

            const trackerTime = Number(track.config_version);
            const configTime = new Date(config.modified_at_timestamp).getTime() / 1000;

            yield put(setScrapeTask(track));
            if((trackerTime - configTime) !== 0) {
                const urlsArray = responce.map(({ url }) => url);
                const dataQuickStart = {
                    ...QUICK_START_DATA,
                    branch_code: branch_codes,
                    receiver_code
                };

                const quickStart = yield all(urlsArray.map((url) => call(createQuickStartRequest, { ...dataQuickStart, url })));
                const track_ids = quickStart.map(({ track_id: { track_id } }) => track_id);
                const initial_track_ids = quickStart.map(({ track_id: { initial_track_id } }) => initial_track_id);

                yield handleCheckTrackIds(initial_track_ids);

                const stepSearchParams = {
                    template_code,
                    branch_codes,
                    receiver_code,
                    storage_type_code,
                    initial_track_id: initial_track_ids,
                    track_id: track_ids
                };

                sharedHistory.push(`${window.location.pathname}?${queryString.stringify(stepSearchParams)}`);
            }
        }

        yield put(setIsLoading(false));
    } catch (error) {
        yield put(setIsLoading(false));
        getErrorMessage(error);
    }
}

export function* handleUpdateConfigData(payload) {
    try {
        yield put(setIsLoading(true));

        yield call(editConfigRequest, payload);

        yield put(setIsLoading(false));

    } catch (error) {
        yield put(setIsLoading(false));

        throw new Error(error);
    }
}

export function* generalSagas() {
    yield all([
        yield takeLatest(requestConfigData, handleRequestInitialScrapeTask)
    ]);
}
